/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
import React, { useState, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { logo as PMZoneLogo } from '../../Constants/assets';
import fetchConfig from '../../Constants/fetch';
import { TutorialsAndFAQ } from '../../components';
import Login from '../Login/Login';
import i18n, { changeLanguage, getLanguages } from '../../i18n'


const PageContainer = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    overflow: hidden;
`;

const SectionContainer = styled.div`
    width: 70%;
    min-height: 90vh;
    display: flex;
    flex-direction: column;
`;

const FaqSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 60px 0px 0px -40px;
    overflow-y: auto; /* Allows internal scrolling if content overflows */
    height: 90vh;
`;

const LoginFormSection = styled.div`
    width: 35%;
    // position: 'sticky';
    bottom: 0;
    top: ${props => (props.isSticky ? '0px' : 'auto')};
`;

const VideoSection = styled.section`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 25px;
`;

const AccordionSection = styled.div``;

const PageTitles = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
const PageContent = styled.div`
    // margin-top: 30px;
`;
const HeaderContent = styled.div`
    margin-bottom: 30px;
    // font-weight: bold;
`;

const Title = styled.h2`
    font-weight: 700;
    font-size: 24px;
`;
const SectionTitle = styled.h5`
    font-weight: 500;
`;

const NewLoginPage = ({
    onlyShowModal,
    toggleModal,
    handleLogin,
    setPlayerEmail,
    playerEmail,
    askRestoreGame,
    getArrayOfAccountsByEmail,
    gameEventId,
    gameCreationDateTime,
    checkZoomMessage,
    languagesList,
    currentLanguage,
    setCurrentLanguage,
    shortCutLanguage,
    setInstructorAndAccountId
}) => {
    const [videoList, setVideoList] = useState([]);
    const [FAQList, setFAQList] = useState([]);
    const [languages, setLanguages] = useState([]);

    const isTrue = true;
    const { t } = useTranslation();
    // const getToturials = async () => {
    //     try {
    //         const tutorials = await axios.get(`${fetchConfig.prefix}/auth/tutorials`);
    //         setVideoList(tutorials.data.videos);
    //         setFAQList(tutorials.data.faq);
    //         console.log(tutorials);
    //     } catch {
    //         console.log('Cant get toturials');
    //     }
    // };

    useEffect(() => {
        const fetchLanguages = async () => {
            const translationsData = await getLanguages();

            const languagesList2 = Object.values(translationsData);

            setLanguages(languagesList2);
        };

        fetchLanguages();
    }, []);

    return (
        <>
            <PageContainer>
                <FaqSection>
                    <SectionContainer>
                        <HeaderContent>
                            <PMZoneLogo />
                            <Title>
                                {t('login.help.help_title')}
                            </Title>
                            <p dangerouslySetInnerHTML={{ __html: t('login.help.help_subtitle').replace(/\n/g, '<br/>') }}></p>
                        </HeaderContent>
                        <TutorialsAndFAQ isLogin={isTrue} />
                    </SectionContainer>
                </FaqSection>
                <LoginFormSection>
                    <Login
                        onlyShowModal={onlyShowModal}
                        toggleModal={toggleModal}
                        handleLogin={handleLogin}
                        setPlayerEmail={setPlayerEmail}
                        playerEmail={playerEmail}
                        askRestoreGame={askRestoreGame}
                        getArrayOfAccountsByEmail={getArrayOfAccountsByEmail}
                        gameEventId={gameEventId}
                        gameCreationDateTime={gameCreationDateTime}
                        checkZoomMessage={() => checkZoomMessage()}
                        languagesList={languagesList}
                        currentLanguage={currentLanguage}
                        setCurrentLanguage={setCurrentLanguage}
                        shortCutLanguage={shortCutLanguage}
                        setInstructorAndAccountId={setInstructorAndAccountId}
                    />
                </LoginFormSection>
            </PageContainer>
        </>
    );
};

export default NewLoginPage;
